import { render, staticRenderFns } from "./IncrementalOnboardingAddBankAccount.vue?vue&type=template&id=5e88a3a2&"
import script from "./IncrementalOnboardingAddBankAccount.vue?vue&type=script&lang=js&"
export * from "./IncrementalOnboardingAddBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports